import {
  PosProvider,
  useGetCaptureRateChannelMappingsQuery,
  useGetCaptureRateRevenueSourcesQuery,
} from 'api/captureRate'
import { useMemo } from 'react'
import { buildRevenueSourceRows } from './revenueSourceGrouping'

export function useRevenueSources(
  locationId: number | undefined,
  posFilter: PosProvider | 'all' = 'all'
) {
  const {
    currentData: mappingsData,
    isFetching: mappingsFetching,
    error: mappingsError,
  } = useGetCaptureRateChannelMappingsQuery()
  const {
    currentData: revenueData,
    isFetching: revenueFetching,
    error: revenueError,
  } = useGetCaptureRateRevenueSourcesQuery({ locationId })

  const rows = useMemo(() => {
    if (!mappingsData || !revenueData) return []

    const mappings =
      posFilter === 'all'
        ? mappingsData.mappings
        : mappingsData.mappings.filter(
            mapping => mapping.provider === posFilter
          )
    const sources =
      posFilter === 'all'
        ? revenueData.sources
        : revenueData.sources.filter(
            source => source.channel.provider === posFilter
          )

    return buildRevenueSourceRows(mappings, sources)
  }, [mappingsData, revenueData, posFilter])

  return {
    rows,
    // Gated on missing data, not bare isFetching -- isFetching is also true
    // during a background refetch (e.g. after a mutation's invalidatesTags
    // fires), and the page unmounts the table under this flag. Checking
    // currentData keeps that unmount for a genuine first load / args change,
    // without tearing the table down on every refetch.
    isLoading:
      (mappingsFetching && !mappingsData) || (revenueFetching && !revenueData),
    error: mappingsError || revenueError,
  }
}
